export default "__VITE_ASSET__CZzSSqNj__"